export default class uploadedVehiclesController {
  constructor(
    $injector,
    $translates,
    $rootScope,
    $uploadedVehicles,
    $auth,
    $scope
  ) {
    'ngInject';
    this.$auth = $auth;
    this.$scope = $scope;
    this.$translates = $translates;
    this.$uploadedVehicles = $uploadedVehicles;
    this.$rootScope = $rootScope;
    this.operators = [];
    this.data = {};
    this.currentOperatorCode = null;
    this.notify   = $injector.get('ngNotify');
    document.getElementById('xlsxFileInput').addEventListener('change',
      function(e) {
      this.handleFile(e);
      }.bind(this), false);
    this.$uploadedVehicles.getAllOperators();
    this.ready = false;
  }

  $onInit(){
    this.fetchAll();
  }

  fetchAll() {
    this.ready = false;
    if (this.company) {
      console.log('company', this.company);
      this.$uploadedVehicles.company = this.company;
      this.$uploadedVehicles.getOperators()
        .then(data => {
          this.operators = data;
          this.$uploadedVehicles.getUploadedVehicles()
            .then(data => {
              this.data = data;
              this.ready = true;
            });
        });
    }
  }

  handleFile(e) {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = window.XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      let jsonData = window.XLSX.utils.sheet_to_json(sheet, { header: 1 });

      document.getElementById('xlsxFileInput').value = null;

      if (jsonData.length && jsonData[0][0] === 'Vehicle' || jsonData[0][1] === 'Length') {
        console.log(jsonData);
        jsonData.shift();
        jsonData = jsonData.map(el => ({'vehicle': el[0].replace(/ /g, '').toUpperCase(), 'length': el[1].toString()}))

        console.log(jsonData);
        this.data[this.currentOperatorCode] = jsonData;
        this.currentOperatorCode = null;
        this.$scope.$apply();
      } else {
        this.currentOperatorCode = null;
        this.notify.set(this.$translates.get('UPLOADED_VEHICLES_BAD_FILE'), 'error')
      }
    };

    reader.readAsArrayBuffer(file);
  }

  count(operator_code) {
    if (this.data[operator_code]) {
      return this.data[operator_code].length;
    } else {
      return 0;
    }
  }

  download(operatorCode) {
    if (!this.data || !this.data[operatorCode] || !this.data[operatorCode].length) {
      this.notify.set(this.$translates.get('NOTHING_TO_DOWNLOAD'), 'error');
      return;
    }
    const jsonData = this.data[operatorCode];

    const headers = ['Vehicle', 'Length'];
    const ws = window.XLSX.utils.json_to_sheet(jsonData);
    ws['A1'].v = headers[0];
    ws['B1'].v = headers[1];
    const wb = window.XLSX.utils.book_new();
    window.XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    window.XLSX.writeFile(wb, `${operatorCode}.xlsx`);
  }

  $upload($event, operator_code) {
    $event && $event.preventDefault();
    console.log(operator_code);
    this.currentOperatorCode = operator_code;
    document.getElementById('xlsxFileInput').click();
  }

  $download($event, operator_code) {
    $event && $event.preventDefault();
    this.download(operator_code);
  }

  $onDelete($event, operator_code) {
    $event && $event.preventDefault();
    delete this.data[operator_code];
  }

  $save($event) {
    $event && $event.preventDefault();
    console.log(this.data);
    this.$uploadedVehicles.saveUploadedVehicles(JSON.stringify(this.data))
      .then(() => {
        this.$rootScope.$emit('reloadUploadedVehicles');
        this.close();
      });
  }

  $onSelect() {
    this.blurActive();
    this.$scope.formAppuploadedVehicles.$setUntouched();
  }

  $createNew() {
    this.isNew = true;
    this.invoiceAccount = {};
  }

  $onClose($event){
    $event.preventDefault();
    this.close({$value: 'cancel'});
  }

};


/** WEBPACK FOOTER **
 ** ./frontend/components/uploadedVehicles/uploadedVehicles.controller.js
 **/